import React from "react";
import styles from "./styles.module.scss";

export type StatsVariant =
    | "blue"
    | "purple"
    | "cyan"
    | "green"
    | "red";

export interface StatsItem {
    label: string;
    value: number | string;
    variant: StatsVariant;
    iconSrc: string;
}

interface StatsSummaryProps {
    items: StatsItem[];
}

const StatsSummary: React.FC<StatsSummaryProps> = ({ items }) => {
    return (
        <div className={styles.container}>
            {items.map((item) => (
                <div
                    key={item.label}
                    className={`${styles.card} ${styles[item.variant]}`}
                >
                    <div className={styles.cardContent}>
                        <div
                            className={`${styles.iconWrapper} ${styles[`icon_${item.variant}`]}`}
                        >
                            <img
                                src={item.iconSrc}
                                alt={`${item.label} icon`}
                                className={styles.iconImage}
                            />
                        </div>

                        <div className={styles.textBlock}>
                            <span className={styles.label}>{item.label}</span>
                            <span
                                className={`${styles.value} ${styles[`value_${item.variant}`]}`}
                            >
                                {item.value}
                            </span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default StatsSummary;
